import slugify from 'slugify';

export const toPrettyString = (obj: any) => JSON.stringify(obj, null, 2);
export const decodeURIPlus = (s: string) => decodeURIComponent(s.replace(/\+/g, ' '));
export const toSlug = (s: any) => slugify(String(s)).toLowerCase();
export const findMatchingSlugifiedValue = (values: string[], slugifiedValue: string): string =>
    values.find((value: any) => slugify(value).toLowerCase() === slugifiedValue.toLowerCase()) as string;

